import {
GET_FEATURES,
GET_USERS,
GET_MACHINES,
GET_EQUIPMENTS,
SET_MONTH,
SET_YEAR,
GET_VEHICLE_ALERTS,
GET_REPORT_TITLES,
GET_DEPARTMENTS,GET_AREAS,
GET_TOOLBOX,
GET_TOOLBOX_TITLES,
GET_ALL_REPORTS,
GET_JOB_PACKS,
GET_REPORTS,
GET_USER_DEVICE_INFO
} from "./types";
import moment from "moment";
const INITIAL_STATE = {
    requesting: false,
    features: false,
    users: false,
    machines: false,
    qrs: false,
    month: moment().format("MMM").toLowerCase(),
    year: moment().format("YYYY"),
    alerts: false,
    reportTitles: false,
    departments: false,
    areas: false,
    toolbox: false,
    toolboxTitles: false,
    reports: false,
    jobpacks: false,
    receiptReports : false,
    userDeviceInfo : false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_REPORTS.REQUEST:{
            return { ...state, requesting: true, receiptReports: false };
        }
        case GET_REPORTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                receiptReports: action.payload
            };
        }
        case GET_REPORTS.FAIL: {
            return { ...state, requesting: false, receiptReports: false };
        }
        case GET_FEATURES.REQUEST: {
            return { ...state, requesting: true, features: false };
        }
        case GET_FEATURES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                features: action.payload
            };
        }
        case GET_FEATURES.FAIL: {
            return { ...state, requesting: false, features: false };
        }
        case SET_MONTH: {
            return { ...state, month: action.payload };
        }
        case SET_YEAR: {
            return { ...state, year: action.payload };
        }
        case GET_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case GET_VEHICLE_ALERTS.REQUEST: {
            return { ...state, requesting: true, alerts: false };
        }
        case GET_VEHICLE_ALERTS.FAIL: {
            return { ...state, requesting: false, alerts: false };
        }
        case GET_VEHICLE_ALERTS.SUCCESS: {
            return { ...state, requesting: false, alerts: action.payload };
        }
        case GET_MACHINES.REQUEST: {
            return { ...state, requesting: true, machines: false };
        }
        case GET_MACHINES.FAIL: {
            return { ...state, requesting: false, machines: false };
        }
        case GET_MACHINES.SUCCESS: {
            return { ...state, requesting: false, machines: action.payload };
        }
        case GET_EQUIPMENTS.REQUEST: {
            return { ...state, requesting: true, qrs: false };
        }
        case GET_EQUIPMENTS.FAIL: {
            return { ...state, requesting: false, qrs: false };
        }
        case GET_EQUIPMENTS.SUCCESS: {
            return { ...state, requesting: false, qrs: action.payload };
        }
        case GET_REPORT_TITLES.REQUEST: {
            return { ...state, requesting: true, reportTitles: false };
        }
        case GET_REPORT_TITLES.FAIL: {
            return { ...state, requesting: false, reportTitles: false };
        }
        case GET_REPORT_TITLES.SUCCESS: {
            return { ...state, requesting: false, reportTitles: action.payload };
        }
        case GET_DEPARTMENTS.REQUEST: {
            return { ...state, requesting: true, departments: false };
        }
        case GET_DEPARTMENTS.FAIL: {
            return { ...state, requesting: false, departments: false };
        }
        case GET_DEPARTMENTS.SUCCESS: {
            return { ...state, requesting: false, departments: action.payload };
        }
        case GET_TOOLBOX.REQUEST: {
            return { ...state, requesting: true, toolbox: false };
        }
        case GET_TOOLBOX.FAIL: {
            return { ...state, requesting: false, toolbox: false };
        }
        case GET_TOOLBOX.SUCCESS: {
            return { ...state, requesting: false, toolbox: action.payload };
        }
        case GET_TOOLBOX_TITLES.REQUEST: {
            return { ...state, requesting: true, toolboxTitles: false };
        }
        case GET_TOOLBOX_TITLES.FAIL: {
            return { ...state, requesting: false, toolboxTitles: false };
        }
        case GET_TOOLBOX_TITLES.SUCCESS: {
            return { ...state, requesting: false, toolboxTitles: action.payload };
        }
        case GET_ALL_REPORTS.REQUEST: {
            return { ...state, requesting: true, reports: false };
        }
        case GET_ALL_REPORTS.FAIL: {
            return { ...state, requesting: false, reports: false };
        }
        case GET_ALL_REPORTS.SUCCESS: {
            return { ...state, requesting: false, reports: action.payload };
        }
        case GET_JOB_PACKS.REQUEST: {
            return { ...state, requesting: true, jobpacks: false };
        }
        case GET_JOB_PACKS.FAIL: {
            return { ...state, requesting: false, jobpacks: false };
        }
        case GET_JOB_PACKS.SUCCESS: {
            return { ...state, requesting: false, jobpacks: action.payload };
        }

        case GET_USER_DEVICE_INFO.REQUEST:{
            return { ...state, requesting: true, userDeviceInfo: false };
        }
        case GET_USER_DEVICE_INFO.SUCCESS: {
            return {
                ...state,
                requesting: false,
                userDeviceInfo: action.payload
            };
        }
        case GET_USER_DEVICE_INFO.FAIL: {
            return { ...state, requesting: false, userDeviceInfo: false };
        }
        case GET_AREAS.REQUEST: {
            return { ...state, requesting: true, areas: false };
        }
        case GET_AREAS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                areas: action.payload
            };
        }
        case GET_AREAS.FAIL: {
            return { ...state, requesting: false, areas: false };
        }
        default: {
            return state;
        }
    }
};
